import { render, staticRenderFns } from "./AccountPass.vue?vue&type=template&id=703ff208&scoped=true&"
import script from "./AccountPass.vue?vue&type=script&lang=js&"
export * from "./AccountPass.vue?vue&type=script&lang=js&"
import style0 from "./AccountPass.vue?vue&type=style&index=0&id=703ff208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ff208",
  null
  
)

export default component.exports